/**
 * 统一时间显示：北京时间（Asia/Shanghai）。
 *
 * 后端存储/返回的日期时间多为 UTC 无时区字符串（如 "2026-10-20T08:28:57"），
 * 解析时必须按 UTC 处理，再强制以 Asia/Shanghai 显示，
 * 否则会被当成浏览器本地时间，导致最多 8 小时偏差（且随访客时区而变，无法统一）。
 */

export function parseUTC(value?: string | null | Date): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value).trim();
  // 已是带时区字符串（含 Z 或 ±HH:MM）则原样解析；否则按 UTC 解析
  const hasTz = /[zZ]$/.test(s) || /[+-]\d{2}:?\d{2}$/.test(s);
  const d = new Date(hasTz ? s : s + 'Z');
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 完整日期时间：YYYY/MM/DD HH:MM:SS（北京时间） */
export function fmtDateTimeCST(value?: string | null | Date): string {
  const d = parseUTC(value);
  if (!d) return '-';
  return d.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

/** 仅日期：YYYY/MM/DD（北京时间） */
export function fmtDateCST(value?: string | null | Date): string {
  const d = parseUTC(value);
  if (!d) return '-';
  return d.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

/** 简短日期时间：MM/DD HH:MM（北京时间） */
export function fmtDateTimeShortCST(value?: string | null | Date): string {
  const d = parseUTC(value);
  if (!d) return '-';
  return d.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
